import * as api from "../Api/index";
import { loadFailed } from "../utils/errorMessage";
export const getIntangibleAssets = () => async (dispatch) => {
  try {
    const { data } = await api.fetchIntangibleAssets();
    dispatch({ type: "FETCH_ALL_INTANGIBLE_ASSETS", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};
